
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Star } from "lucide-react";
import { Link } from "react-router-dom";

interface Review {
  id: string;
  reviewer_name: string;
  rating: number;
  text: string;
  created_at: string;
}

interface ReviewSectionProps {
  reviews: Review[];
  isLoading: boolean;
  sellerId: string;
  reviewCount: number;
}

const ReviewSection = ({
  reviews,
  isLoading,
  sellerId,
  reviewCount,
}: ReviewSectionProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Reviews</CardTitle>
        <CardDescription>
          Feedback from previous buyers
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {isLoading ? (
            <div className="space-y-4">
              <div className="h-20 bg-gray-100 rounded animate-pulse"></div>
              <div className="h-20 bg-gray-100 rounded animate-pulse"></div>
            </div>
          ) : reviews && reviews.length > 0 ? (
            reviews.slice(0, 3).map((review) => (
              <div key={review.id} className="border-b pb-4 last:border-0">
                <div className="flex items-center gap-2 mb-2">
                  <div className="font-medium">{review.reviewer_name}</div>
                  <div className="text-sm text-gray-500">
                    {new Date(review.created_at).toLocaleDateString()}
                  </div>
                </div>
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <Star 
                      key={i}
                      className={`h-4 w-4 ${i < review.rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`}
                    />
                  ))}
                </div>
                <p className="text-gray-700">{review.text}</p>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 py-4">No reviews available yet.</p>
          )}
        </div>
      </CardContent>
      {reviews && reviews.length > 3 && (
        <CardFooter>
          <div className="text-center w-full">
            <Link to={`/sellers/${sellerId}/reviews`}>
              <Button variant="outline" className="w-full sm:w-auto">
                View All Reviews ({reviewCount})
              </Button>
            </Link>
          </div>
        </CardFooter>
      )}
    </Card>
  );
};

export default ReviewSection;
